import styled from 'styled-components';

const StyledTrackProgressBar = styled.div`
  width: 100%;

  .fr-track-progress-bar {
    width: 100%;

    &__slider {
      width: 100%;
      height: 6px;
      position: relative;
    }
  }
`;

export default StyledTrackProgressBar;
